import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../endpoints'

export async function getCarlot(id) {
    const response = await axios.get(`${REACT_APP_API_ABM_FW}/abms/car_lot/${id}`)
    return response?.data?.data
}